import React, { useEffect } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { activateAuthLayout } from '../../../store/actions';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { useQuery } from '@apollo/react-hooks';
import env from '../../../env';

const DATA = gql`
  query Data($QuoteId: ID) {
    Quote(QuoteId: $QuoteId) {
      QuoteId
      ProposalTitle
      Token
    }
  }
`;

const QuoteBuilderPreviewTemplate = ({ activateAuthLayout, ...props }) => {
  useEffect(() => { activateAuthLayout(); }, [activateAuthLayout]);

  const { data, loading } = useQuery(DATA, { variables: { QuoteId: props.quoteId } });

  return (
    <React.Fragment>
      {data && data.Quote && !loading && (
        <div className="content">
          <div className="container-fluid">
            <div className="page-title-box">
              <Row className="align-items-center">
                <Col sm="6">
                  <h4 className="page-title">{data.Quote.ProposalTitle} - Preview Proposal</h4>
                </Col>
              </Row>
            </div>

            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="text-center">
                    <Row className="my-5">
                      <Col lg={{ size: 8, offset: 2 }}>
                        <i style={{ fontSize: '140px' }} className="fas fa-file-contract mb-4" />
                        <button
                          className="btn btn-info btn-lg btn-block my-1"
                          onClick={(e) => { e.preventDefault(); window.open(`${env.PROPOSAL_BASE_URL}${data.Quote.Token}`, '_blank'); }}
                        >
                          Preview Proposal
                        </button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      )}

      {data && data.Quote === null && !loading && (
        <div className="content">
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>Quote with id {props.quoteId} does not exist.</CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default connect(null, { activateAuthLayout })(QuoteBuilderPreviewTemplate);
